import { render, staticRenderFns } from "./TextAreaUI.vue?vue&type=template&id=5947fc89&scoped=true&"
import script from "./TextAreaUI.vue?vue&type=script&lang=js&"
export * from "./TextAreaUI.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaUI.vue?vue&type=style&index=0&id=5947fc89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5947fc89",
  null
  
)

export default component.exports